import { styled } from "@mui/system";
import { Button } from "@mui/material";

export default styled(Button)(({
    textTransform: "none",
    minWidth: 180,
    height: 45
}));
